export type SelectedCountry = { id?: string; name?: string };

export const useSelectedCountry = (selectInput: HTMLSelectElement | null): SelectedCountry => {
    return {
        name: selectInput?.children[selectInput?.selectedIndex]?.innerHTML,
        id: selectInput?.value,
    };
};
